<template>
	<section class='leaveStu'>
    <Row>
    	<Breadcrumb>
    		<BreadcrumbItem to="">食堂消费</BreadcrumbItem>
    		<BreadcrumbItem to="">消费记录</BreadcrumbItem>
    	</Breadcrumb>
    </Row>
		<Row xs="20" sm="16" md="12" lg="8">
      <Col span="5"  >
      		<DatePicker type="daterange" @on-change='getDateData' :split-panels='true'  placement='bottom-start' placeholder="日期区间（默认当天）" style='width:100%;margin-left:1px'></DatePicker>
      </Col>
			<Col span='3'>
				<Input v-model="searchParam.name" placeholder="姓名" />
			</Col>
      <Col span='3'>
				<Input v-model="searchParam.phone" placeholder="手机号" />
			</Col>
      <!-- <Col span='4'>
        <Select v-model="searchParam.sn"  >
						<Option v-for='(item,indexs) in lcdlist' :key='indexs' :value="item.guid">
							{{item.name}}
						</Option>
					</Select>
			</Col> -->
			<Col span='1'>
				<Button type="info" @click='searchData'>查询</Button>
			</Col>
      <Col span='5'>
          <div class='xfMoney'>
            消费金额：￥<span> {{curMoney}} </span>
          </div>
      </Col>
    </Row>
    <div  style='display:flex;justify-content:space-between;margin-top:20px;'>
          <div id='pdData' class='pdData'  >
              <div :class='[index == curIndex ? "active" : ""]' class='itempd' v-for='(item,index) in departlist'  @click='tabPD(item,index)'>{{item.name}}</div>
              
           </div>
          <ul class='conheadRight'>
            
            <!-- <Button type="info" class='downcsv' icon="ios-card"  style='margin:0 10px 0 0px;'  @click='exportTotalData'>导出总汇总</Button> -->
            <Button type="primary" class='downcsv' icon="ios-card"  @click='exportData'>导出汇总</Button>
          </ul>

		</div>
		<section class='tabelContent'>
			<tablePage border :queryData="queryData" :searchParam='searchParam' :issearch='issearch' @extradata='extradata'></tablePage>
		</section>


    <Modal v-model='removelistModal' width='600px' title='撤销本次消费' >
				<Form :model="formItem" :label-width="120">
              <FormItem label="姓名">
                  <Input  v-model="formItem.name"  disabled placeholder=""></Input>
              </FormItem>
             <FormItem label="消费金额">
               <Input type='number' disabled v-model="formItem.amount" placeholder=""></Input>
             </FormItem>
              <FormItem label="设备名称">
                <Input type='text' v-model="formItem.devicename" disabled placeholder=""></Input>
              </FormItem>
              <FormItem label="备注">
                <Input type='text' v-model="formItem.remark" placeholder=""></Input>
              </FormItem>
				</Form>
        <div slot="footer" style='position:relative;clear:both'>

                  
          <Button type="default" @click='removelistModal=false' icon="md-close">取消</Button>
          <Button type="info" @click='updateLesson' icon="md-checkmark-circle-outline">保存</Button>
        </div>
		</Modal>
	</section>
</template>

<script>
	import getDates from '../utils/index'
	import tablePage from './tablePage'
	import bemodal from './formItem'
  import util from '../utils/index.js'
	export default {
		name: 'canteenRecord',
		components: {
			tablePage,
			bemodal,
		},
		data() {
			return {
        curStuInfo:{},
        removelistModal:false,
        curIndex:0,
        departlist:[],
				formItem:{
					name:'',
					amount:0,
				  devicename:'',
          remark:'',
				},
        curMoney:0,
				addMoney:false,
				hisData:'',
				columnshis:[],
				showhis:false,
				showpay:false,
				smodal: false,
				reloadTmep: -1,
				initformData:[],
				queryData: ['',
					[{
							title: '姓名',
							key: 'name',
							render: (h, params) => {
								var pic = params.row.facepic?params.row.facepic:''
								var _firstLetter = params.row.name.substr(0, 1)
								if(pic){
									return h('viewer',[
												h('img', {
														style: {//设置样式
															width:'28px',
															height:'28px',
															'border-radius': '50%',
															lineHeight:'28px',
															display:'inline-block',
															position:'absolute',
														},
														attrs: {//设置属性
															src: pic
														}
												}),
												h('span',{
													style: {
														fontWeight:'bold',
														width:'30px',
														height:'30px',
														paddingLeft:'44px',
														lineHeight:'30px',
													},
												},params.row.name)
											])
								}else{
									return  h('div',[
												h('span', {

													style: {
														display:'inline-block',
														width:'30px',
														height:'30px',
														background:'rgba(237,76,120,.1)',
														borderRadius:'50%',
														textAlign:'center',
														lineHeight:'30px',
														color:'#ed4c78',
														marginRight:'14px'
													},
												}, _firstLetter),
												h('span',{

													style: {
														fontWeight:'bold'
													},
												},params.row.name),
												])
								}

							}
						},
            {
            	title: '所属部门',
            	key: 'departname',
            	align: 'center',
            },
            {
            	title: '消费金额（元）',
            	key: 'amount',
            	align: 'center',
            },
            {
            	title: '消费方式',
            	key: '',
            	align: 'center',
              render: (h, params) => {
              	var item = params.row.type
              	if(item ==1){
              		return h('span','人脸')
              	}else if(item==2){
              		return h('span','APP扫码')
              	}else if(item==3){
              		return h('span','刷卡')
              	}else{
                  return h('span','')
                }
              }
            },
            {
            	title: '设备名称',
            	key: 'devicename',
            	align: 'center',
            },
						{
							title: '消费时间',
							key: 'addtime',
							align: 'center',
						},
            {
							title: '备注',
							key: 'remark',
							align: 'center',
              width:250,
						},
            {
							title: '操作',
							slot: 'action',
							width: 120,
							align: 'center',
							render:(h,params)=>{
                if(params.row.amount<0){
                  return h('span','撤销记录')
                }else{
                  if(params.row.iscancel == 0){
                    return  h('div',[
                        h('span', {
                          style: {
                            display:'inline-block',
                            width:'60px',
                            height:'25px',
                            background:'#2db7f5',
                            borderRadius:'6px',
                            textAlign:'center',
                            lineHeight:'25px',
                            color:'#fff',
                            fontSize:'12px',
                            cursor:'pointer',
                            userSelect:'none'
                          },
                          on: {
                            click: () => {
                              console.log(params.row)
                              this.curStuInfo = params.row
                              this.formItem = {
                                name: params.row.name,
                                amount:params.row.amount,
                                devicename:params.row.devicename,
                              }
                              this.removelistModal = true
                          
                            }
                          }
                        }, '撤销')
                    ])
                 
                  }else{
                    return h('span','该记录已被撤销')
                  }
                 
                }
							}
            },
					]
				],
				searchParam: {
          phone:'',
					name:'',
          starttime:'',
          endtime:'',
          sn:'',
          departid:'',
				},
				issearch: -1,
				isshowpay: -1,
				isshowhis: -1,
				userInfo:{},
        lcdlist:[]
			}
		},
		mounted(){

			this.userInfo = JSON.parse(localStorage.getItem('inchUserinfo'))
      console.log(this.getLcd())
      this.getDepart()
		},
		methods: {
      updateLesson(){
        var that = this 
        var _remark = that.formItem.remark ? that.formItem.remark : ''
        if(_remark == ''){
          that.$Message.info('请填写撤销备注')
          return false;
        }
        this.$Modal.confirm({
          title: '提示',
          content: '<p>是否确认撤销？</p>',
          onOk: () => {
            that.axios.post('canteenRecord/cancelWebRecord',{guid:that.curStuInfo.guid,remark:_remark}).then((a) =>{
              console.log(a,'aaa')
              if(a.success){
                that.$Message.info(a.msg)
                that.searchData()
              }else{
                that.$Message.error(a.msg)
              }
              that.removelistModal = false
            })
          },
          onCancel: () => {

          }
        });
      },
      delXFlist(){
        // /canteenRecord/cancelWebRecord
      },
      tabPD(item,index){
        console.log(item,index)
        var that = this 
        this.curIndex = index 
      
        this.searchParam.departid = item['guid']
       
        that.searchData()
      },
      getDepart(){
      
        var that = this
      
      
        this.axios.get('dic/getQueryList',{params:{rootid:'depart',length:-1}}).then((a) =>{
          console.log(a,'a')
          that.curItem = a['data'][0]
          that.departlist = a.data
          that.queryData[0] = 'canteenRecord/getQueryList.do'
          that.searchParam.departid= that.curItem['guid']
          that.searchData()
        })
        
      },
      getLcd(){
        var that = this 
        this.axios.get('canteenDevice/getQueryList',{params:{}}).then((a) =>{
					console.log(a,'aaa')
          that.lcdlist = a.data
        })
      },
      extradata(val){
        this.curMoney = val || 0
      },
			searchData() {
        if(this.searchParam.sn){
          console.log(this.searchParam.sn)
          this.searchParam.sn = this.searchParam.sn ||  this.searchParam.sn.join(',')
          this.queryData[0] = 'canteenRecord/getTotalBySN'
          this.issearch = Math.random()
        }else{
          this.queryData[0] = 'canteenRecord/getQueryList'
          this.issearch = Math.random()
        }
				
			},
			reloadTable() {
				this.issearch = Math.random()
			},
      getDateData(a,b){

      	this.searchParam.starttime = a[0]
      	this.searchParam.endtime = a[1]
      },
      showMenu(){
      	this.$Message.info('功能开发中')
      },
      exportData(){
          var param  =  this.searchParam
          var tHeader = ['姓名','所属部门','消费金额（元）','消费设备','消费时间','备注']
          var filterVal = ['name','departname','amount','devicename','addtime','remark']
           var _title  = ''
          if(this.searchParam['starttime']&&this.searchParam['endime']){
             _title = this.searchParam['starttime']+'~'+this.searchParam['endime']+'消费记录'
          }else{
             _title =  '消费记录'
          }

          util.exportExcel('canteenRecord/getQueryList',param,_title,tHeader,filterVal)
          // canteenRecord/getTotalAmount.json
      },
      exportTotalData(){
          var param  =  this.searchParam
          var tHeader = ['姓名','消费金额（元）','消费设备','消费时间']
          var filterVal = ['name','amount','devicename','addtime']
           var _title  = ''
          if(this.searchParam['starttime']&&this.searchParam['endime']){
             _title = this.searchParam['starttime']+'~'+this.searchParam['endime']+'消费记录'
          }else{
             _title =  '消费记录'
          }

          util.exportExcel('canteenRecord/getTotalAmount.json',param,_title,tHeader,filterVal)
          // canteenRecord/getTotalAmount.json
      },
		}
	}
</script>

<style scoped>
	.tabelContent {
		margin-top: 20px;
	}
	.leaveStu{
		flex:1;
		padding-right:25px!important;
		/* overflow: scroll; */
		padding-bottom:50px;
		padding-top:20px;
		overflow-x:hidden;
	}
	.leaveStu .ivu-row:first-of-type {
		margin-top: 5px;
	}

	.leaveStu .ivu-row {
		margin-top: 20px;
		/* 	overflow:hidden; */
		position: relative;
	}

	.leaveStu .ivu-col {
		margin-right: 10px;
		/* float:left; */
	}

	.leaveStu .ivu-col:last-of-type {
		float: left;
		margin-left: 0px;
		/* position:absolute;
		right:0px; */
	}

	.demo-upload-list {



		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		overflow: hidden;
		margin-right: 4px;
		margin-bottom: 5px;
	}

	.demo-upload-list img {
		width: 40px;
		height: 40px;
		float: left;
		margin-right: 15px;
	}

	.demo-upload-list span {
		line-height: 40px;
		font-size: 12px;
		float: left;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 10px;
		line-height: 40px;

	}

	#hwSchool {
		position: relative;
	}

	#hwSchool .ivu-tree {
		position: absolute;
		top: 33px;
		left: 0px;
		background: #fff;
		z-index: 1000;
		width: 300px;
		height: 300px;
		border: 1px solid #dcdee2;
		border-top: 0 none;
		overflow-y: scroll;
		overflow-x: hidden;
		padding-left: 10px;
	}

	.modalUl {
		width: 100%;
		display: flex;
		justify-content: space-between;


	}

	.modalUl li {
		list-style: none;

	}

	.modalUl>li:first-of-type {
		width: 35%;
		height: 100%;
		height: 400px;
		overflow-y: scroll;
		overflow-x: hidden;
	}

	.modalUl>li:last-of-type {
		flex: 1;
		padding-left: 30px;
	}

	.treeContent {}

	.hwImgCon {
		margin-top: 10px;

	}

	.hwImgCon img {
		width: 55px;
		height: 55px;
		border-radius: 5px;
	}

	.conheadRight {
		float: right;
		margin-right: 00px;
	}
  .xfMoney{
    height:32px;
    line-height:32px;
    margin-left:30px;
  }
  .xfMoney span{
    font-weight:bold;
    font-size:24px;
    position:relative;
    top:1px;
  }
  .pdData {
    display: flex;
    justify-content: flex-start;
    list-style:none;
    flex-wrap: wrap;
  }
  .itempd {
    height: 32px;
    line-height: 32px;
    border-radius: 20px;
    padding: 0 15px;
    font-size: 14px;
    margin-right: 10px;
    cursor: pointer
  }

  .itempd.active {
    background-color: #00d186;
    border-color: #00d186;
    color: #fff;
  }
</style>
